import React, { useState, useEffect } from "react";
import Layout from "../../layout";
import "./produits.scss";
import { db } from "../../base";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const ListChainesPl = () => {
  const [collection, setCollection] = useState([]);
  const [data, setData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  let url = "";

  useEffect(() => {
    let prevScrollpos = window.pageYOffset;
    window.onscroll = () => {
      const currentScrollpos = window.pageYOffset;
      prevScrollpos = currentScrollpos;
      const navBar = document.getElementById("li_fixed");
      if (prevScrollpos < 43) {
        navBar.classList.remove("top_fixed");
        navBar.classList.add("top");
      } else if (prevScrollpos > currentScrollpos) {
        navBar.classList.remove("top_fixed");
        navBar.classList.add("top");
      } else {
        navBar.classList.remove("top");
        navBar.classList.add("top_fixed");
      }
    };
  }, []);

  useEffect(() => {
    db.collection("json")
      .where("name", "==", "chaines-pl.json")
      .onSnapshot((snapshot) => {
        setCollection(
          snapshot.docs.map((doc) => ({
            url: doc.data().url,
          }))
        );
      });
  }, []);

  collection.map((info) => (url = info.url));

  useEffect(() => {
    fetch(url, { mode: "cors" })
      .then(function (response) {
        return response.json();
      })
      .then(function (myJson) {
        setData(myJson);
        setIsFetching(false);
      });
  }, [url]);

  const [valueSearch, setValueSearch] = useState("");

  const handleDeleteSearch = () => {
    setValueSearch("");
  };

  if (isFetching) {
    return <p className="loading">Chargement des données...</p>;
  }

  return (
    <Layout title={"Chaînes PL"}>
      <div id="produits" className="pages">
        <div className="search">
          <p>Chercher une référence</p>
          <div className="input_button">
            <input
              type="text"
              value={valueSearch}
              onChange={(event) => setValueSearch(event.target.value)}
            />
            <button onClick={handleDeleteSearch}>
              <FontAwesomeIcon className="delete" icon={faTimes} />
            </button>
          </div>
        </div>
        <ul>
          <li id="li_fixed">
            <div className="t4">Référence</div>
            <div className="t4">Designation</div>
            <div className="t1">Disponible</div>
            <div className="t1">HTBrut</div>
          </li>
          {data.A.filter((val) => {
            if (valueSearch == "") {
              return val
            } else if (val.appellation.toLowerCase().includes(valueSearch.toLocaleLowerCase())) {
              return val
            }
          }).map((info) => (
            <li key={info.appellation}>
              {info.appellation && <div className="t4">{info.appellation}</div>}
              {info.designation && <div className="t4">{info.designation}</div>}
              {info.disponible > 0 ? <div className="t1">{info.disponible}</div> : <div className="t1"><span style={{color: "red"}}>0</span></div>}
              {info.htbrut && <div className="t1">{info.htbrut}€</div>}
            </li>
          ))}
        </ul>
      </div>
    </Layout>
  );
};

export default ListChainesPl;
